// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3xdxV","choiceBoxes":"toolbarselects_choiceBoxes__25c8i","simpleField":"toolbarselects_simpleField__3CdgQ"};